import { HeroStage } from './HeroStage';
import { AppleIcon, AndroidIcon, ArrowIcon } from '../icons';
import { APP_STORE_URL, PLAY_STORE_URL } from '../content';

export function Hero() {
  return (
    <header
      className="section"
      id="top"
      style={{ paddingTop: 'calc(var(--nav-h) + 64px)', paddingBottom: 88 }}
    >
      <div
        className="container hero-grid"
        style={{
          display: 'grid',
          gridTemplateColumns: 'minmax(0,1.05fr) minmax(0,0.95fr)',
          gap: 64,
          alignItems: 'center',
        }}
      >
        <div>
          <div className="eyebrow" style={{ marginBottom: 26 }}>
            Cranio · Study of Planes
          </div>
          <h1 className="h-display">
            A studio in
            <br />
            your pocket.
          </h1>
          <p className="h-sub" style={{ marginTop: 24, fontSize: 19 }}>
            Light, pose and study the human head from any angle. Built for figure drawing, portrait
            work and lighting practice — no model, no studio required.
          </p>
          <div
            style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 36 }}
            id="download"
          >
            <a
              className="btn btn-solid"
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <AppleIcon /> App Store
            </a>
            <a
              className="btn btn-ghost"
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <AndroidIcon /> Google Play
            </a>
          </div>
          <a
            href="#features"
            className="mono"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              marginTop: 20,
              fontSize: 11,
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              color: 'var(--fg-3)',
            }}
          >
            See the studio <ArrowIcon />
          </a>
          <div
            style={{
              display: 'flex',
              gap: 26,
              marginTop: 44,
              fontFamily: 'var(--font-mono)',
              fontSize: 11,
              letterSpacing: '0.04em',
              color: 'var(--fg-3)',
            }}
          >
            <span>
              <span style={{ color: 'var(--fg-1)' }}>4</span> head models
            </span>
            <span>
              <span style={{ color: 'var(--fg-1)' }}>12</span> finishes
            </span>
            <span>
              <span style={{ color: 'var(--fg-1)' }}>5</span> live lights
            </span>
          </div>
        </div>
        <HeroStage />
      </div>
    </header>
  );
}
